import { Link } from 'gatsby';
import React from 'react';

import Tag from '_components/tag';
import { urlForArticle, urlForArticleSearchTag } from '_utils/articles';
import { urlFor } from '_utils/images';

export default function ArticleCardVertical({ article }) {
  return (
    <div className="flex flex-col w-full">
      <div className="">
        <Link
          to={urlForArticle(article)}
          className="block w-full pt-[100%] sm:pt-[56%] relative"
        >
          <div className="absolute inset-0">
            <img
              src={urlFor(article.thumbnail)?.width(500).format('webp').url()}
              className="w-full h-full rounded-lg object-cover object-right-bottom"
              alt={article.thumbnail?.asset?.title}
            />
          </div>
        </Link>
      </div>
      <div className="pt-2 sm:py-4 flex-1">
        <Link
          to={urlForArticle(article)}
          className="block font-bold text-base text-content-primary"
        >
          <div className="line-clamp-2">{article.title}</div>
        </Link>
        <div className="hidden sm:block mt-1 text-sm text-content-primary">
          <div className="line-clamp-3">{article.excerpt}</div>
        </div>
        <div className="mt-4 flex gap-x-1">
          {article.tags_v3?.map((tag) => (
            <Link key={tag.key.current} to={urlForArticleSearchTag(tag)}>
              <Tag>{tag.name}</Tag>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
